<template>
  <v-card elevation="0" style="max-width: 100%; margin: auto; padding: 0 30px;display: flex;align-items: center">
    <div class="templateDivBlockPage">
      <div class="TopTemplateDivBlockPage">
        <img src="/app/img/wifi.png" style="width: 140px;height: 113px;margin: 13px auto;" alt="wifi.png">
        <h2>عدم اتصال به اینترنت</h2>
        <h4>لطفا اتصال اینترنت دستگاه را بررسی کنید</h4>
      </div>

      <div @click="checkConnection" class="ButtonCloseApp">
        بررسی اتصال
      </div>

    </div>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "connection",
  mounted() {
  },
  computed: {
  },
  methods: {
    ...mapMutations(["setToken"]),
    checkConnection() {
      let self=this;
      if (this.$store.getters.auth.loggedIn) {
        self.$router.push({name: 'home'})
      } else {
        self.$router.push({name: 'login'})
      }
    }
  }
}
</script>

<style>
.templateDivBlockPage {
  margin: 30% auto;
  width: 90%;
  height: 400px;
}

.TopTemplateDivBlockPage {
  height: 250px;
  background: rgba(168, 168, 168, 0.2);
  border-radius: 10px;
  text-align: center;
  padding-top: 10px;
}

.TopTemplateDivBlockPage h3 {}

.TopTemplateDivBlockPage h4 {
  font-size: .95rem;
}

.TopTemplateDivBlockPage img {
  margin: 0 auto;
  text-align: center;
  width: 130px;
  height: 150px;
  margin-bottom: 10px;
}

.ButtonCloseApp {
  height: 50px;
  border-radius: 10px;
  background: #00ba8e;
  text-align: center;
  line-height: 50px;
  margin-top: 30px !important;
  color: white;
  margin-top: 10px;
  cursor: pointer;
}
</style>
